var DEFAULT_HIDE_DELAY, DEFAULT_SHOW_DELAY, ToolTipDelayView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

DEFAULT_SHOW_DELAY = 1000;

DEFAULT_HIDE_DELAY = 100;

module.exports = ToolTipDelayView = (function(superClass) {
  extend(ToolTipDelayView, superClass);

  function ToolTipDelayView() {
    this.hideToolTip = bind(this.hideToolTip, this);
    this.showToolTip = bind(this.showToolTip, this);
    return ToolTipDelayView.__super__.constructor.apply(this, arguments);
  }

  ToolTipDelayView.prototype.showDebounce = null;

  ToolTipDelayView.prototype.hideDebounce = null;

  ToolTipDelayView.prototype.events = {
    'mouseenter': 'showToolTip',
    'mouseleave': 'hideToolTip'
  };

  ToolTipDelayView.prototype.initialize = function(arg) {
    this.eventName = arg.eventName, this.showDelay = arg.showDelay, this.hideDelay = arg.hideDelay;
    if (this.eventName == null) {
      this.eventName = 'showdelayed';
    }
    if (this.showDelay == null) {
      this.showDelay = DEFAULT_SHOW_DELAY;
    }
    if (this.hideDelay == null) {
      this.hideDelay = DEFAULT_HIDE_DELAY;
    }
    this.cacheElem();
    return this.initToolTipElemHandlers();
  };

  ToolTipDelayView.prototype.cacheElem = function() {
    return this.$toolTipElem = $("#" + (this.$el.data('tooltip-id')));
  };

  ToolTipDelayView.prototype.initToolTipElemHandlers = function() {
    this.$toolTipElem.on('mouseenter', this.showToolTip);
    return this.$toolTipElem.on('mouseleave', this.hideToolTip);
  };

  ToolTipDelayView.prototype.showToolTip = function() {
    if (this.hideDebounce) {
      this.hideDebounce = clearTimeout(this.hideDebounce);
    }
    if (this.showDebounce) {
      return;
    }
    return this.showDebounce = setTimeout(((function(_this) {
      return function() {
        return _this.$el.trigger(_this.eventName);
      };
    })(this)), this.showDelay);
  };

  ToolTipDelayView.prototype.hideToolTip = function() {
    if (this.showDebounce) {
      this.showDebounce = clearTimeout(this.showDebounce);
    }
    if (this.hideDebounce) {
      return;
    }
    return this.hideDebounce = setTimeout(((function(_this) {
      return function() {
        return GIG.Tooltip.close(_this.$toolTipElem);
      };
    })(this)), this.hideDelay);
  };

  return ToolTipDelayView;

})(Backbone.View);

//# sourceMappingURL=data:application/json;base64,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
